var DEFAULT_HIDE_DELAY, DEFAULT_SHOW_DELAY, ToolTipDelayView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

DEFAULT_SHOW_DELAY = 1000;

DEFAULT_HIDE_DELAY = 100;

module.exports = ToolTipDelayView = (function(superClass) {
  extend(ToolTipDelayView, superClass);

  function ToolTipDelayView() {
    this.hideToolTip = bind(this.hideToolTip, this);
    this.showToolTip = bind(this.showToolTip, this);
    return ToolTipDelayView.__super__.constructor.apply(this, arguments);
  }

  ToolTipDelayView.prototype.showDebounce = null;

  ToolTipDelayView.prototype.hideDebounce = null;

  ToolTipDelayView.prototype.events = {
    'mouseenter': 'showToolTip',
    'mouseleave': 'hideToolTip'
  };

  ToolTipDelayView.prototype.initialize = function(arg) {
    this.eventName = arg.eventName, this.showDelay = arg.showDelay, this.hideDelay = arg.hideDelay;
    if (this.eventName == null) {
      this.eventName = 'showdelayed';
    }
    if (this.showDelay == null) {
      this.showDelay = DEFAULT_SHOW_DELAY;
    }
    if (this.hideDelay == null) {
      this.hideDelay = DEFAULT_HIDE_DELAY;
    }
    this.cacheElem();
    return this.initToolTipElemHandlers();
  };

  ToolTipDelayView.prototype.cacheElem = function() {
    return this.$toolTipElem = $("#" + (this.$el.data('tooltip-id')));
  };

  ToolTipDelayView.prototype.initToolTipElemHandlers = function() {
    this.$toolTipElem.on('mouseenter', this.showToolTip);
    return this.$toolTipElem.on('mouseleave', this.hideToolTip);
  };

  ToolTipDelayView.prototype.showToolTip = function() {
    if (this.hideDebounce) {
      this.hideDebounce = clearTimeout(this.hideDebounce);
    }
    if (this.showDebounce) {
      return;
    }
    return this.showDebounce = setTimeout(((function(_this) {
      return function() {
        return _this.$el.trigger(_this.eventName);
      };
    })(this)), this.showDelay);
  };

  ToolTipDelayView.prototype.hideToolTip = function() {
    if (this.showDebounce) {
      this.showDebounce = clearTimeout(this.showDebounce);
    }
    if (this.hideDebounce) {
      return;
    }
    return this.hideDebounce = setTimeout(((function(_this) {
      return function() {
        return GIG.Tooltip.close(_this.$toolTipElem);
      };
    })(this)), this.hideDelay);
  };

  return ToolTipDelayView;

})(Backbone.View);

//# sourceMappingURL=data:application/json;base64,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
